var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrmIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5592_19576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5V17.5H17.5V2.5H2.5ZM16.25 16.25H3.75V3.75H16.25V16.25Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11.25H11.25V12.5H15V11.25Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H5V10H15V5ZM13.75 8.75H6.25V6.25H13.75V8.75Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25H5V15H10V11.25ZM8.75 13.75H6.25V12.5H8.75V13.75Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13.75H11.25V15H15V13.75Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5592_19576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIcons);
export default __webpack_public_path__ + "static/media/CrmIcons.e453d12aaee2aeded40aa0d2f7e1cfc0.svg";
export { ForwardRef as ReactComponent };